import '../css/Rodape.css';

function Rodape() {
    return (
        <footer>
            <p>© 2022 Desenvolvido por Gleison Alves de Araujo</p>
        </footer>
    );
}

export default Rodape;